import { Modal, Button } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loader from "../Loader";
import { MEANS_OF_TRANSPORT_TYPES } from "../enum";
const phoneRegExp = /^(^\+251|^251|^0)?9\d{8}$/;
const basicSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last Name is required"),
  address: Yup.string().required("Address is required"),
  gender: Yup.string().required("Gender is required"),
  driverScince: Yup.date()
    .nullable()
    .required("Driver Scince  is required")
    .max(new Date(), "Start Date must be earlier than today"),
  documents: Yup.mixed().required("Document is required"),
  driverImage: Yup.mixed().required("Image is required"),
  phoneNumber: Yup.string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required(),
  password: Yup.string().required("Password is required"),
  confPassword: Yup.string().required("Confirm password is required"),
  status: Yup.string().required("Status is required"),
  transportType: Yup.string().required("Means of Transport is required"),
});

const RegisterDriver = ({ registerer, link }) => {
  const [showModal, setShowModal] = useState(true);
  const [hideModal, setHideModal] = useState(false);
  // console.log(
  //   "=======local storage data====",
  //   JSON.parse(localStorage.getItem("userData")).id
  // );
  const history = useNavigate();
  let [loading, setLoading] = useState(false);
  let [errorMsg, setErrorMsg] = useState(true);
  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    addDriver(values);
    setLoading(true);
  };
  const user = JSON.parse(localStorage.getItem("userData"));

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
    submitForm,
  } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      gender: "",
      driverScince: "",
      phoneNumber: "",
      address: "",
      driverImage: "",
      documents: "",
      password: "",
      confPassword: "",
      status: "",
      registered_by: registerer,
      registerer_id: user.id,
      transportType: "",
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const DatePickerField = ({ name, value, onChange }) => {
    return (
      <DatePicker
        selected={(value && new Date(value)) || null}
        onChange={(val) => {
          onChange(name, val);
        }}
      />
    );
  };
  const notifySuccess = () =>
    toast.success("Driver Added.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const addDriver = async (e) => {
    try {
      const bodyFormData = new FormData();
      for (let value in values) {
        bodyFormData.append(value, values[value]);
      }
      console.log("==========add driver=============");

      const response = await axios
        .post("/drivers", bodyFormData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
            // Other headers if required
          },
        })
        .then((res) => {
          history(link);
          hideModal();
          notifySuccess();
        })
        .catch((err) => {
          console.log("==========add driver=========err====", err);
          setLoading(false);
          setErrorMsg(err.response.data.msg);
          notifyError();
        });
    } catch (error) {
      console.log("==========add driver=========error====", error);
      notifyError();
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      encType="multipart/form-data"
    >
      {/* <Modal
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        contentClassName="custom-modal-style"
      > */}
      <div
        contentClassName="custom-modal-style"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "80%",
          margin: "10px",
          marginLeft: "15%",
        }}
      >
        <Modal.Body>
        style={{marginTop: "60px"}}
          {loading && (
            <div
              style={{
                position: "absolute",
                zIndex: "1000",
                top: 50 + "%",
                left: 50 + "%",
              }}
            >
              <Loader />
            </div>
          )}

          <div class="row">
            <div>
              <Modal.Header>
                <Modal.Title>Add Driver</Modal.Title>
              </Modal.Header>
            </div>

            <div class="col-md-6">
              <div class="card card-primary">
                <div class="card-body">
                  <div class="form-group">
                    <label for="inputName">First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      value={values.firstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.firstName && touched.firstName
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.firstName && touched.firstName && (
                      <p className="error">{errors.firstName}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      value={values.lastName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.lastName && touched.lastName
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.lastName && touched.lastName && (
                      <p className="error">{errors.lastName}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Phone Number</label>
                    <input
                      type="text"
                      id="inputName"
                      name="phoneNumber"
                      value={values.phoneNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.phoneNumber && touched.phoneNumber
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.phoneNumber && touched.phoneNumber && (
                      <p className="error">{errors.phoneNumber}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="inputStatus">Gender</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="gender"
                      value={values.gender}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.gender && touched.gender
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Gender</option>
                      <option value={"Male"}>Male</option>
                      <option value={"Female"}>Female</option>
                    </select>
                    {errors.gender && touched.gender && (
                      <p className="error">{errors.gender}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="inputTransportType">Means of Transport</label>
                    <select
                      id="inputTransportType"
                      name="transportType"
                      value={values.transportType}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.transportType && touched.transportType
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option value="">Select Means of Transport</option>
                      {Object.entries(MEANS_OF_TRANSPORT_TYPES).map(([key, value]) => (
                        <option key={value} value={key}>
                          {key.charAt(0) + key.slice(1).toLowerCase()}
                        </option>
                      ))}
                    </select>
                    {errors.transportType && touched.transportType && (
                      <p className="error">{errors.transportType}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Address</label>
                    <input
                      type="text"
                      id="inputName"
                      name="address"
                      value={values.address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.address && touched.address
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.address && touched.address && (
                      <p className="error">{errors.address}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputEstimatedBudget">Driver Scince Year</label>

                    <DatePickerField
                      name="driverScince"
                      id="inputEstimatedBudget"
                      class="form-control"
                      value={values.driverScince}
                      onChange={setFieldValue}
                      className={
                        errors.driverScince && touched.driverScince
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />

                    {errors.driverScince && touched.driverScince && (
                      <p className="error">{errors.driverScince}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card card-success">
                <div className="card-body">
                  <div class="form-group">
                    <label for="exampleInputFile">Driver Image</label>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFile"
                          name="driverImage"
                          accept="image/*"
                          onChange={(e) =>
                            setFieldValue(
                              "driverImage",
                              e.currentTarget.files[0]
                            )
                          }
                          className={
                            errors.driverImage && touched.driverImage
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.driverImage && touched.driverImage && (
                      <p className="error">{errors.driverImage}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="exampleInputFile">Legal Documents</label>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFileq"
                          name="documents"
                          onChange={(event) => {
                            setFieldValue(
                              "documents",
                              event.currentTarget.files[0]
                            );
                          }}
                          onBlur={handleBlur}
                          className={
                            errors.documents && touched.documents
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.documents && touched.documents && (
                      <p className="error">{errors.documents}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Password</label>
                    <input
                      type="password"
                      id="inputName"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.password && touched.password
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.password && touched.password && (
                      <p className="error">{errors.password}</p>
                    )}
                  </div>
                  <div class="form-group">
                    <label for="inputName">Confirm Password</label>
                    <input
                      type="password"
                      id="inputName"
                      name="confPassword"
                      value={values.confPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.confPassword && touched.confPassword
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.confPassword && touched.confPassword && (
                      <p className="error">{errors.confPassword}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label for="inputStatus">Status</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.status && touched.status
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Status</option>
                      <option value={"Active"}>Active</option>
                      <option value={"Inactive"}>Inactive</option>
                    </select>
                    {errors.status && touched.status && (
                      <p className="error">{errors.status}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Modal.Footer>
              {errorMsg && (
                <div>
                  <h5 className="error">{errorMsg}</h5>
                </div>
              )}
              <Button variant="default" onClick={hideModal}>
                Cancel
              </Button>

              <button
                disabled={isSubmitting}
                onClick={submitForm}
                className="btn btn-success"
                type="submit"
              >
                Submit
              </button>
            </Modal.Footer>
          </div>
        </Modal.Body>
      </div>
      {/* </Modal> */}
    </form>
  );
};

export default RegisterDriver;
